import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CollectionTypeToggleTypesComponent } from '../collection-type-toggle-types.shared.component';

@Component({
    selector: 'shared-collection-type-toggle-for-button-drop-down',
    templateUrl: './collection-type-toggle-for-button-drop-down.shared.component.html',
    styleUrls: ['./collection-type-toggle-for-button-drop-down.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectionTypeToggleForButtonDropDownComponent extends CollectionTypeToggleTypesComponent {

}


